import { render, staticRenderFns } from "./myEvidence.vue?vue&type=template&id=2b06794a&scoped=true&"
import script from "./myEvidence.vue?vue&type=script&lang=js&"
export * from "./myEvidence.vue?vue&type=script&lang=js&"
import style0 from "./myEvidence.vue?vue&type=style&index=0&id=2b06794a&prod&lang=less&"
import style1 from "./myEvidence.vue?vue&type=style&index=1&id=2b06794a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b06794a",
  null
  
)

export default component.exports